import { arrayOf, func, string } from 'prop-types';
import React from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalHeader,
} from 'reactstrap';

import CategorySelect from '../../generic/CategorySelect';
import createModalToggle from '../../generic/create-modal-toggle';
import MultiSelect from '../../generic/MultiSelect';
import SingleSelect from '../../generic/SingleSelect';
import convertToOption from '../../utils/convert-to-option';
import getEventTargetValue from '../../utils/get-event-target-value';
import {
  countryOptions,
  genderOptions,
  imageTypeOptions,
  originOptions,
} from '../constants';

class EditorModalContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      origin: originOptions[0].value,
      genders: [],
      mediaSet: null,
      imageType: [],
      countryCodes: [],
      categories: [],
      productTags: [],
    };

    this.update = this.update.bind(this);
  }

  componentWillUnmount() {
    this.props.onClose();
  }

  update(event) {
    const { name } = event.target;
    const value = getEventTargetValue(event.target);
    this.setState({ [name]: value });
  }

  render() {
    const { toggle, onChange, campaignProductTags } = this.props;
    const {
      origin,
      genders,
      mediaSet,
      imageType,
      countryCodes,
      categories,
      productTags,
    } = this.state;

    return (
      <>
        <ModalHeader toggle={toggle}>Edit the selected creatives</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup row>
              <Label for="bulk.mediaSet" sm={3}>
                Media Set
              </Label>
              <Col sm={7}>
                <Input
                  id="bulk.mediaSet"
                  name="mediaSet"
                  value={mediaSet || ''}
                  onChange={this.update}
                />
              </Col>
              <Col sm={2}>
                <Button
                  id="confirm:bulk.mediaSet"
                  onClick={() => onChange('mediaSet', mediaSet)}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="bulk.genders" sm={3}>
                Genders
              </Label>
              <Col sm={7}>
                <MultiSelect
                  options={genderOptions}
                  id="bulk.genders"
                  name="genders"
                  value={genders}
                  className="c-campaign-line-select"
                  onChange={this.update}
                />
              </Col>
              <Col sm={2}>
                <Button
                  id="confirm:bulk.genders"
                  onClick={() => onChange('genders', genders)}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="bulk.countryCodes" sm={3}>
                Countries
              </Label>
              <Col sm={7}>
                <MultiSelect
                  options={countryOptions}
                  id="bulk.countryCodes"
                  name="countryCodes"
                  value={countryCodes}
                  className="c-campaign-line-select"
                  onChange={this.update}
                />
              </Col>
              <Col sm={2}>
                <Button
                  id="confirm:bulk.countryCodes"
                  onClick={() => onChange('countryCodes', countryCodes)}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="bulk.categories" sm={3}>
                Categories
              </Label>
              <Col sm={7}>
                <CategorySelect
                  id="bulk.categories"
                  name="categories"
                  value={categories}
                  className="c-campaign-line-select"
                  onChange={this.update}
                />
              </Col>
              <Col sm={2}>
                <Button
                  id="confirm:bulk.categories"
                  onClick={() => onChange('categories', categories)}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="bulk.productTags" sm={3}>
                Product Tags
              </Label>
              <Col sm={7}>
                <MultiSelect
                  options={campaignProductTags.map(convertToOption)}
                  id="bulk.productTags"
                  name="productTags"
                  value={productTags}
                  className="c-campaign-line-select"
                  onChange={this.update}
                />
              </Col>
              <Col sm={2}>
                <Button
                  id="confirm:bulk.productTags"
                  onClick={() => onChange('productTags', productTags)}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="bulk.origin" sm={3}>
                Origin
              </Label>
              <Col sm={7}>
                <SingleSelect
                  options={originOptions}
                  id="bulk.origin"
                  name="origin"
                  value={origin}
                  className="c-campaign-line-select"
                  onChange={this.update}
                />
              </Col>
              <Col sm={2}>
                <Button
                  id="confirm:bulk.origin"
                  onClick={() => onChange('origin', origin)}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="bulk.imageType" sm={3}>
                Image type
              </Label>
              <Col sm={7}>
                <MultiSelect
                  options={imageTypeOptions}
                  hideSelectedOptions={false}
                  closeMenuOnSelect={false}
                  id="bulk.imageType"
                  name="imageType"
                  value={imageType}
                  className="c-campaign-line-select"
                  onChange={this.update}
                />
              </Col>
              <Col sm={2}>
                <Button
                  id="confirm:bulk.imageType"
                  onClick={() => onChange('imageType', imageType)}
                >
                  Update
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
      </>
    );
  }
}

EditorModalContent.propTypes = {
  onChange: func.isRequired,
  onClose: func.isRequired,
  toggle: func.isRequired,
  campaignProductTags: arrayOf(string),
};

EditorModalContent.defaultProps = {
  campaignProductTags: [],
};

export default createModalToggle(
  'Edit Selected',
  EditorModalContent,
  { color: 'secondary', outline: true, size: 'sm' },
  { size: 'lg' },
);

export { EditorModalContent };
